import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=64b4808c&scoped=true"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"
import style0 from "./CreateReport.vue?vue&type=style&index=0&id=64b4808c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4808c",
  null
  
)

export default component.exports